// extracted by mini-css-extract-plugin
export default {"container":"cardList_container__l8zkH","dataCard":"cardList_dataCard__sHhG3"};